module.exports = __webpack_public_path__ + "static/media/6.82da08af.jpg";